import React, { useEffect, useState } from "react"

import { convertDateTime } from "../../utils/utils"
import Loader from "../Common/Loader/loader"

const NotificationList = (props) => {
    const { notifications, totalRecords, pageLimit, isfetching, 
        onfetch, currentPage, handleReadAndRedirect } = props
    const totalnoOfPages = Math.ceil(totalRecords / pageLimit)

    const [divHeight, setDivHeight] = useState(document.documentElement.clientHeight);
    useEffect(() => {
        const handleResize = () => {
            setDivHeight(document.documentElement.clientHeight)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        const element = document.getElementById("scrollDiv")
        element?.addEventListener("scroll", infiniteScroll)

        if (element?.scrollTop === 0) {
            element.scrollTop = element?.scrollHeight - element?.clientHeight - 50
        }
    }, [notifications])

    const infiniteScroll = () => {
        const element = document.getElementById("scrollDiv")
        if (element?.scrollHeight - Math.round(element?.scrollTop) <= element?.clientHeight + 10) {
            if (currentPage < totalnoOfPages) {
                document.getElementById("scrollDiv")?.removeEventListener("scroll", infiniteScroll)
                onfetch()
            }
        }
    }

    return (
        <>
            { notifications?.length > 0 ? (
                <div
                    className={ `flex pt-[24px] pb-[8px] 
                      flex-col gap-[12px] items-start overflow-y-auto custome-scroll` }
                    id={ "scrollDiv" }
                    style={ { height: `${divHeight}px` } }
                >
                    { notifications?.map((notification) => {
                        const { title, description, created_at, isRead, url_id, entity_id } = notification
                        return (
                            <>
                                <button                                   
                                    className="flex w-full"
                                    onClick={ () => {  
                                        handleReadAndRedirect(notification?.id, url_id, entity_id, isRead) 
                                    }
                                    }
                                >
                                    <div className={ `flex items-start gap-[4px] 
                                    self-stretch pb-[12px] border-b solid border-gray w-full` }>
                                        <div className="flex pt-[4px] items-start gap-[10px]">
                                            <div
                                                className={ `flex w-[8px] h-[8px] flex-col justify-center 
                                              items-center gap-[10px] 
                                              rounded-full ${ !isRead ? "bg-tertiary-500" : "bg-transparant"}` }
                                            ></div>
                                        </div>
                                        <div className="flex flex-col items-start gap-[8px] self-stretch">
                                            <div className="flex flex-col items-start self-stretch">
                                                <label className={ `text-sm font-bolder text-blue 
                                              hover:underline hover:underline-offset-4 text-left` }>
                                                    { title }
                                                </label>
                                                <label className="text-sm font-normal text-secondary-200 
                                                    text-left">
                                                    { description }
                                                </label>
                                            </div>
                                            <label className="text-xs font-light text-secondary-200">
                                                { convertDateTime(created_at) }
                                            </label>
                                        </div>
                                    </div>
                                </button>
                            </>
                        )
                    }) }
                </div>
            ) : (
                notifications?.length === 0 && (
                    <div className="text-center	pt-[40px] text-lightGray text-2xl font-black w-full">
                        { "No Notifications found" }
                    </div>
                )
            ) }
            <Loader loading={ isfetching }></Loader>
        </>
    )
}

export default NotificationList
